import React from 'react'

const About = () => {
  return (
    <div>
     njdsfsdsdkewf
     dfjkfjdd
    </div>
  )
}

export default About
